import { RefundRequestStatus } from "./types";
import moment from "moment-timezone";
import { Moment } from "moment";

export const isChecklistLocked = (status: RefundRequestStatus) => {
  return (
    [
      RefundRequestStatus.AwaitingManualChecklistItems,
      RefundRequestStatus.AwaitingChecklistCompletion,
      RefundRequestStatus.Stuck,
      RefundRequestStatus.ChecklistComplete,
    ].indexOf(status) < 0
  );
};

export const isRequestRefundable = (status: RefundRequestStatus) => {
  return [RefundRequestStatus.ChecklistComplete, RefundRequestStatus.PartiallyRefunded].indexOf(status) > -1;
};

export const isRequestRefunded = (status: RefundRequestStatus) => {
  return status === RefundRequestStatus.FullyRefunded;
};

export const toSydneyDate = (date: Date | string): Moment => {
  return moment.tz(date, "Australia/Sydney");
};

export const convertDateToSydneyDateString = (date: Date): string => {
  return toSydneyDate(date).format("YYYY-MM-DD");
};

export const encodeSubOrderId = (subOrderId: string | null): string => {
  return (subOrderId || "").replace("/", "~");
};
